import $ from 'jquery';

export function showLoadingOverlay() {
 $('#js-loading').removeClass('d-none');
}

export function hideLoadingOverlay() {
 $('#js-loading').addClass('d-none');
}

export default function setupLoadingOverlay() {
 // L'evento viene lanciato solo quando si clicca sulla classe seguente
 $('.js-loading-overlay').on('click', (evt) => {
  // Solo se viene cliccato il tasto sinistro del mouse faccio partire l'animazione di caricamento
  // Diversamente se viene cliccato il tasto centrale non fa partire l'animazione
  if (evt.which === 1) {
   showLoadingOverlay(true);
  }
 });
}
